import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export class AuthError extends Error {
  constructor(message, code = '') {
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}

export async function loginWithBackend({ email, password }) {
  const response = await fetch(`${API_BASE}/auth/login/admin`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new AuthError(
      parseApiError(payload, 'Error de login'),
      payload.code || '',
    );
  }

  if (payload.user?.userType !== 'ADMIN') {
    throw new Error('Esta cuenta no tiene permisos de administrador');
  }

  return {
    user: payload.user,
    accessToken: payload.accessToken,
    refreshToken: payload.refreshToken,
    tokenType: payload.tokenType,
    expiresIn: payload.expiresIn,
  };
}

export async function fetchMyProfile() {
  const response = await apiFetch(`${API_BASE}/auth/me`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudo validar sesión'));
  }
  return payload;
}
